import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { SafePipe } from '../../pipes/safe.pipe';
import { NotificationType } from '../../enums';
import { INotification } from '../../models';


@Component({
	selector: 'notification-message',
	templateUrl: './notification-message.component.html',
	imports: [NgbAlertModule, TranslateModule, SafePipe]
})
export class NotificationMessageComponent implements OnInit {
	@Input() notification: INotification;
	@Input() autoCloseDelay = 3000;
	@Input() dismissDelay = 300;
	@Output() dismissEvent = new EventEmitter<void>();

	type: string;
	animatingClass = '';

	ngOnInit() {
		if (!!this.notification.options && this.notification.options.autoCloseDelay) {
			this.autoCloseDelay = this.notification.options.autoCloseDelay;
		}

		this.type = {
			[NotificationType.ERROR]: 'danger',
			[NotificationType.SUCCESS]: 'success',
			[NotificationType.WARNING]: 'warning',
		}[this.notification.type] || '';

		// add a class for the animation of the alert
		window.setTimeout(() => this.animatingClass = 'in');

		if (this.notification.autoClose) {
			window.setTimeout(() => this.dismiss(), this.autoCloseDelay);
		}
	}

	dismiss() {
		this.animatingClass = '';
		window.setTimeout(() => this.dismissEvent.emit(), this.dismissDelay);
	}
}
